import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const RETURN_KEY = "auth_return_path";

export const AuthReturnHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const returnPath = sessionStorage.getItem(RETURN_KEY);
    if (!returnPath) return;

    void supabase.auth.getUser().then(({ data }) => {
      if (!data.user) return;
      sessionStorage.removeItem(RETURN_KEY);
      navigate(returnPath, { replace: true });
    });
  }, [navigate]);

  return null;
};